module.exports = __webpack_public_path__ + "static/sec-20d00cbe4be953b38829f7d89289d6b2.svg";